module.exports = __webpack_public_path__ + "static/media/Disputeresolution.41ac544e.jpg";